import gql from "graphql-tag";

export const MUTATION_UI = gql`
    mutation updateUi($ui: Ui!) {
        updateUi(ui: $ui) @client
    }
`;
